var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hm-no-data-card",class:{
    'hm-no-data-card--border': _vm.showBorder,
  }},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e(),(_vm.toRouteName)?_c('router-link',{attrs:{"to":{
      name: _vm.toRouteName,
    }}},[_c('HMButton',{attrs:{"color":"brand"}},[_vm._v(" "+_vm._s(_vm.toLabel)+" ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }